import Lottie from 'lottie-react';
import {
  BannerBox,
  DefaultBox,
  FloatinArea,
  FloatingBox,
  FooterSpace,
  ListBox,
  ScrollXBox,
  SegmentBox,
  SideBox,
} from '../etc/LBox/LBox';
import Observer from '../etc/Observer/Observer';
import Rolling from '../component/Rolling/Rolling';
import InfoCard from '../etc/InfoCard/InfoCard';
import { UnderLineText } from '../typography/Typography.styled';

import useLanding from '../../application/bloc/useLanding';
import useFooter from '../../application/hooks/useFooter';

import {
  Alert,
  Button,
  Card,
  Divider,
  HeadTitle,
  Icon,
  SpacerSection,
  Tbd24,
  Tbd28,
  TheFooter,
  Tmd14,
} from 'oui';

import loanNumberCount from '../../assets/gif/loan_number_count.gif';
import rateNumberCount from '../../assets/gif/rate_number_count.gif';
import logoAnimation from '../../assets/lottie/logo_animation.json';
import { PAGE_NM } from '../../application/types/types';

const CreditLanding = () => {
  const {
    navigateOvertake,
    navigateOvertakePrivacy,
    navigateOnlineLoanCorp,
    navigateTestPage,
  } = useFooter();

  const {
    hasBannerList,
    bannerList,

    navigateCreditResult,
    navigateCreditOrMyDataByAppversion,
    navigatePartners,
    navigateBannerToPage,
    navigateStatus,

    sendBeaconClkBtnLoanApp,
    sendBeaconClkBtnBnkList,
    sendBeaconClkBtnNotiSchAlrt,
    sendBeaconClkBtnIntrstCalc,
    sendBeaconClkBtnLoanPrg,

    isTodayRequested,
    isFloating,
    setIsFloating,
    hasLoanStatus,
    loanStatusCount,

    cardList,

    media,
    terms,
  } = useLanding(PAGE_NM.HOME);

  const handleClickMainButton = (e?: any) => {
    sendBeaconClkBtnLoanApp(e.target.innerHTML || '');
    if (isTodayRequested) {
      navigateCreditResult();
    } else {
      terms.showTerm();
    }
  };

  const handleClickCreditButton = () => {
    navigateCreditOrMyDataByAppversion && navigateCreditOrMyDataByAppversion();
  };

  const handleClickPartnersButton = (e: any) => {
    sendBeaconClkBtnBnkList(e.target.innerText || '');
    navigatePartners();
  };
  const handleClickSimpleList = (idx: number) => {
    if (hasLoanStatus) {
      if (idx === 0) {
        handleClickLoanStatus();
      } else {
        navigateBannerToPage(idx - 1);
        // if (idx === 1) {
        //   sendBeaconClkBtnNotiSchAlrt('정기 알림');
        // }
        if (idx === 1) {
          sendBeaconClkBtnIntrstCalc('이자 계산기');
        }
      }
    } else {
      navigateBannerToPage(idx);
      // if (idx === 0) {
      //   sendBeaconClkBtnNotiSchAlrt('정기 알림');
      // }
      if (idx === 0) {
        sendBeaconClkBtnIntrstCalc('이자 계산기');
      }
    }
  };
  const handleClickLoanStatus = () => {
    navigateStatus();
    sendBeaconClkBtnLoanPrg('대출 진행 현황');
  };

  const Cta = () => (
    <Button
      configuration={'contained'}
      flexible={true}
      onClick={(e: any) => handleClickMainButton(e)}
    >
      {isTodayRequested ? '비교 결과 보러 가기' : '대출 비교하러 가기'}
    </Button>
  );

  return (
    <>
      <>
        {!!loanStatusCount && (
          <SideBox padding="10px 20px">
            <Alert
              text="내 대출 진행 현황"
              count={loanStatusCount}
              onClick={handleClickLoanStatus}
            />
          </SideBox>
        )}
        <DefaultBox>
          <Tbd28 text="빠르고 쉽게" />
          <br />
          <Tbd28 text="대출 비교해 보세요!" />
        </DefaultBox>
        <Lottie animationData={logoAnimation} />
        <DefaultBox>
          <SegmentBox gap={8}>
            <InfoCard>
              <Tmd14 text="최저 금리" />
              <img src={rateNumberCount} alt="최저 금리" width="100%" />
            </InfoCard>
            <InfoCard>
              <Tmd14 text="최고 한도" />
              <img src={loanNumberCount} alt="최고 한도" width="100%" />
            </InfoCard>
          </SegmentBox>
        </DefaultBox>
        <SideBox padding="0 20px 16px">
          <Observer handleState={(e: any) => setIsFloating(e)}>
            <Cta />
          </Observer>
        </SideBox>
      </>
      <FloatinArea>
        {/* <SideBox>
          <Spacer size={'xs'} />
          {simpleList.map((item: any, idx: number) => {
            return (
              <div key={idx + item.subheaderText}>
                <SimpleItem
                  key={idx + item.subheaderText}
                  state={item.avatar.state}
                  avatar={item.avatar}
                  headerText={item.headerText}
                  subheaderText={item.subheaderText}
                  stress={false}
                  onClickSimpleItem={() => handleClickSimpleList(idx)}
                />
                {idx < simpleList.length - 1 && <Spacer size={'sm'} />}
              </div>
            );
          })}
          <Spacer size={'sm'} />
        </SideBox> */}

        <SideBox padding="16px 20px">
          <Tbd24 text="대출비교 조회, 안심하세요!" color="#363636" />
          <ListBox padding="12px 0" gap={8}>
            <SegmentBox gap={10}>
              <Icon name="Gauge" size="xl" />
              <Tmd14
                text="여러번 조회해도 신용점수에 영향이 없어요"
                color="#696969"
              />
            </SegmentBox>
            <SegmentBox gap={10}>
              <Icon name="Security" size="xl" />
              <Tmd14
                text="PASS인증으로 개인정보는 안전하게 보호돼요"
                color="#696969"
              />
            </SegmentBox>
          </ListBox>
          <UnderLineText onClick={handleClickPartnersButton}>
            함께하는 금융사
          </UnderLineText>
        </SideBox>

        {hasBannerList && (
          <BannerBox>
            <Rolling
              items={bannerList}
              onClickItem={(idx) => {
                bannerList[idx].navigate();
                bannerList[idx].beacon.click();
              }}
              onChangeItem={(idx) => {
                bannerList[idx].beacon.view();
              }}
            />
          </BannerBox>
        )}

        <Divider type={'contents'} />
        <SpacerSection
          size={'md'}
          children={
            <>
              <HeadTitle
                textTitle={'다양한 금융 서비스도\n 함께 경험해 보세요'}
              />
              <ScrollXBox>
                {cardList.map((item: any, idx: number) => (
                  <Card
                    key={idx + item.secondaryText + item.primaryText}
                    avatar={item.avatar}
                    text={item.primaryText}
                    subText={item.secondaryText}
                    onClickCard={() => {
                      cardList[idx].beacon();
                      cardList[idx].navigate();
                    }}
                  />
                ))}
              </ScrollXBox>
            </>
          }
        />
        <TheFooter
          type={'a'}
          onClickOnlineLoanCorp={navigateOnlineLoanCorp}
          onClickOvertake={navigateOvertake}
          onClickOvertakePrivacy={navigateOvertakePrivacy}
          onClickTest={navigateTestPage}
          media={media}
        />
        <FloatingBox status={isFloating}>
          <Cta />
        </FloatingBox>
      </FloatinArea>
      <FooterSpace />
    </>
  );
};

export default CreditLanding;
